import styled from 'styled-components';

import { mediaConfined, mediaTopBarHidden } from '@xing-com/layout-tokens';
import { SkeletonBodyCopy, SkeletonButton } from '@xing-com/skeleton';
import {
  scale150,
  scale220,
  scale320,
  spaceL,
  spaceM,
  spaceS,
  spaceXL,
} from '@xing-com/tokens';

const SearchBarContainerSkeleton = styled.div`
  align-items: center;
  display: flex;
  gap: ${spaceM};
  padding: 0 0 ${spaceM};

  @media ${mediaConfined} {
    justify-content: space-between;
    padding: ${spaceL} 0;
  }

  @media ${mediaTopBarHidden} {
    gap: ${spaceL};
    padding: 0 0 ${spaceL};
  }
`;

const SearchBarBodyCopySkeleton = styled(SkeletonBodyCopy)`
  flex: 1;

  @media ${mediaConfined} {
    max-width: ${scale320};
  }
`;

const SearchBarButtonsContainerSkeleton = styled.div`
  display: flex;
  gap: ${spaceS};

  @media ${mediaTopBarHidden} {
    gap: ${spaceXL};
  }
`;

const SearchBarButtonSkeleton = styled(SkeletonButton)`
  height: ${scale150};
  width: ${scale150};

  @media ${mediaTopBarHidden} {
    width: ${scale220};
  }
`;

export const Styled = {
  SearchBarContainerSkeleton,
  SearchBarBodyCopySkeleton,
  SearchBarButtonsContainerSkeleton,
  SearchBarButtonSkeleton,
};
